import { Outlet, createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app/routes/app-route'
import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductLayout } from '@/app/routes/area-layout'

export function ReportsLayout() {
  return (
    <ProductLayout sidebar={<AreaSidebar area="reports" />}>
      <Outlet />
    </ProductLayout>
  )
}

export function GlobalReportsLayout() {
  return (
    <ProductLayout sidebar={<AreaSidebar area="globalReports" />}>
      <Outlet />
    </ProductLayout>
  )
}

export const reportsRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'reports',
  component: ReportsLayout,
})

export const globalReportsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'reports',
  component: GlobalReportsLayout,
})
